import { formatDuration } from 'date-fns';
import { ru } from '@cp/shared/lib/date/locale.ru';
import { parse as parseISO8601Duration } from 'iso8601-duration';
import { PromocodeViewModel } from '@common/model/billing/promocode/view';

export const formatPromocodeFreePeriod = (promocode: Pick<PromocodeViewModel, 'freePeriod'>): string => {
  return promocode.freePeriod ? formatDuration(parseISO8601Duration(promocode.freePeriod), { locale: ru }) : '(период не указан)';
};
